module.exports = __webpack_public_path__ + "tz.svg?013a918cb5127716be57435a40ecfc06";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/tz.svg
// module id = 1211
// module chunks = 27